import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiServerService } from 'src/app/core/services/api/api-server.service';
import { Service } from 'src/app/core/services/misiones/misiones.service';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/data.service';
import { AuthService } from 'src/app/core/authentication/auth.service';
declare var $: any;

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.scss']
})
export class DetalleComponent implements OnInit {

  url = environment.urlBack;
  actividades: any[] = []
  state = null;
  score = null;
  description = null;
  token = null;
  ot = null;
  code = null;
  performer = null;
  section = null;
  station = null;
  when = null;
  ut = null;
  descripcion = null;
  spinner = true;
  missionId = null;
  @Input() esComplete = false;
  @Input() datos: any;
  constructor(
    private router: Router,
    private rutaActiva: ActivatedRoute,
    private service: Service,
    private serviceApi: ApiServerService,
    private authService: AuthService,
    public dialog: MatDialog,
    private el: ElementRef

  ) {

  }
  ngOnInit(): void {
    this.initializeData();
  }
  ngAfterViewInit(): void {
    $(this.el.nativeElement).find('.ui.accordion').accordion();
  }
  goHome() {
    this.router.navigate(['/']);
  }
  @Output() completed = new EventEmitter<void>();

  @Input() instruction: string | undefined;
  @Input() instructionKey: string | undefined;
  initializeData(): void {

    $("#spinner-load").css("display", "block");
    this.missionId = this.rutaActiva.snapshot.params.mission;
    if (this.instruction == null) this.instruction = this.rutaActiva.snapshot.params.instruction;
    this.instructionKey = this.limpiarKey(this.instruction)
    this.serviceApi.getDetail({ missionId: this.missionId, activity: this.instruction }).subscribe(res => {
      if (res.data) {
        this.descripcion = res.data.Protocol_Id;
        this.ot = res.data.Status.OT?.Observed;
        this.code = res.data.Status.Description?.Observed;
        this.score = res.data.score;
        this.station = res.data.Status.CodigoEstacion?.Observed;
        this.state = res.data.state;
        this.section = res.data.Status.Seccion?.Observed;
        this.performer = res.data.Who[0].username;
        this.ut = res.data.Status.Description.Observed;
        this.when = res.data.When;
      }

      this.actividades = res.actividades
      this.spinner = false;

      $('#spinner-load').css("display", "none");

      this.completed.emit();
    }, err => {
      this.spinner = false;
      $('#spinner-load').css("display", "none");
      this.completed.emit();
    })


  }
  limpiarKey(texto: string): string {
    if (!texto) return '';

    return texto
      .normalize('NFD')                     // Descompone acentos (ej: 'á' -> 'a' + '´')
      .replace(/[\u0300-\u036f]/g, '')      // Elimina los acentos (los símbolos flotantes)
      .replace(/[\s,.]/g, '')               // Elimina espacios, comas y puntos
      .replace(/[^a-zA-Z0-9]/g, '');        // (Opcional) Elimina cualquier otro signo especial
  }

  groupByInstructionId(data: { Instruction_Id: number }[]) {
    const groupedData = data.reduce((items, item) => {
      const key = item.Instruction_Id;

      if (!items[key]) {
        items[key] = [];
      }

      items[key].push(item);

      return items;
    }, {});

    const formattedResult = Object.entries(groupedData).map(([key, items]) => ({
      key: key,
      items,
    }));

    return formattedResult;
  }





  groupByActividad(data) {
    const key = "Activity_Dsc";
    return Object.entries(data.reduce((acc, cur) => {
      const actividad = cur[key];
      const sec = cur["Activity_Seq"];

      if (!acc[actividad]) {
        acc[actividad] = {
          key: actividad,
          sec: sec,
          results: [],
        };
      }

      const curCopy = { ...cur };
      acc[actividad].results.push(curCopy);

      return acc;
    }, {})).map(([key, value]) => value);
  }

  filtrarUltimas(preguntas: any) {
    const map = new Map<string, any>();
    preguntas.forEach(obj => {
      const compositeKey = `${obj.Instruction_Id}_${obj.Evidence_Type}`;
      const existingObj = map.get(compositeKey);
      if (!existingObj || obj.When > existingObj.When) {
        map.set(compositeKey, obj);
      }
    });
    const result = Array.from(map.values());
    return result;
  }

  ordenarPreguntas(arr: any) {
    return arr.sort((x, y) => x.Instruction_Seq - y.Instruction_Seq);
  }
  formatearNumero(respuesta) {
    if (!isNaN(respuesta)) {
      if (respuesta % 1 !== 0) {
        respuesta = Number(respuesta).toFixed(2);
      }
    }
    return respuesta;
  }

  activePanel(i) {
    if (document.getElementById("panel" + i).classList.contains("active")) {
      document.getElementById("panel" + i).classList.remove("active");
      document.getElementById("content" + i).classList.remove("active");
    } else {

      document.getElementById("panel" + i).classList.add("active");
      document.getElementById("content" + i).classList.add("active");
    }

  }
}


